export default "__VITE_ASSET__BXvt9lDr__"